(() => {
  if (window.__stickyFixBIS_v8) return;
  window.__stickyFixBIS_v8 = true;

  const STICKY_SEL = '.product-add-to-cart-sticky';
  let scheduled = false;

  const getSticky = () => document.querySelector(STICKY_SEL);

  const forceHide = (el) => {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
  };

  const restore = (el) => {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('opacity');
  };

  // ✅ Detecta OOS por badge “AGOTADO” (tu sticky ya lo muestra)
  const stickyShowsSoldOut = (sticky) => {
  const txt = ((sticky.textContent || '')).toLowerCase();

  const words = [
    window.STICKY_SOLDOUT_LABEL,
    window.STICKY_OOS_LABEL,
      // fallback por si alguna tienda no tiene esas keys bien
      'agotado', 'sold out', 'out of stock', 'épuisé', 'esgotado', 'ausverkauft', 'esaurito'
    ].filter(Boolean).map(s => String(s).toLowerCase());

    return words.some(w => w && txt.includes(w));
  };


  // Oculta BIS inyectado dentro del sticky (duplicados)
  const hideInjectedBISInsideSticky = (sticky) => {
    sticky.querySelectorAll('.bis_template_product, button.bis_ui_button, a.bis_ui_button').forEach(forceHide);
  };

  const getMainNotifyBtn = () => {
    // BIS real (fuera del sticky)
    const bis = Array.from(document.querySelectorAll('button.bis_ui_button, a.bis_ui_button'))
      .find(btn => !btn.closest(STICKY_SEL));
    if (bis) return bis;

    // fallback por texto (fuera del sticky)
    return Array.from(document.querySelectorAll('button, a'))
      .find(el => !el.closest(STICKY_SEL) && /notificarme|notify/i.test((el.textContent || '').trim())) || null;
  };

  const ensureProxy = (sticky) => {
    let proxy = sticky.querySelector('[data-sticky-bis-proxy]');
    if (proxy) return proxy;

    // estilo de referencia (botón del sticky)
    const src =
      sticky.querySelector('#AddToCartSticky') ||
      sticky.querySelector('button[name="add"]') ||
      sticky.querySelector('.button');

    proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.textContent = window.STICKY_NOTIFY_LABEL || 'Notificarme';
    proxy.setAttribute('data-sticky-bis-proxy', '1');

    if (src && src.className) proxy.className = src.className;
    proxy.classList.add('sticky-notify-proxy');

    // Móntalo en un sitio visible (inner)
    const mount = sticky.querySelector('.product-add-to-cart-sticky--inner') || sticky;
    mount.appendChild(proxy);

    proxy.addEventListener('click', (e) => {
      e.preventDefault();
      getMainNotifyBtn()?.click();
    });

    forceHide(proxy);
    return proxy;
  };

  const sync = () => {
    const sticky = getSticky();
    if (!sticky) return;

    const outOfStock = stickyShowsSoldOut(sticky);
    sticky.classList.toggle('is-oos', outOfStock);

    const proxy = ensureProxy(sticky);

    // 👇 IMPORTANTE: en tu sticky hay 2 “add” (desktop y mobile). Restáuralos o escóndelos todos.
    const addBtns = Array.from(sticky.querySelectorAll('button[name="add"], input[name="add"]'));

    hideInjectedBISInsideSticky(sticky);

    if (outOfStock) {
      addBtns.forEach(forceHide);
      proxy.style.setProperty('display', 'inline-flex', 'important'); // que se vea sí o sí
    } else {
      // ✅ Esto arregla el móvil: quitamos cualquier display none que hubiese quedado pegado
      addBtns.forEach(restore);
      forceHide(proxy);
    }
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      try { sync(); } catch (e) {}
    });
  };

  const obs = new MutationObserver(scheduleSync);
  obs.observe(document.documentElement, { subtree: true, childList: true });

  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('DOMContentLoaded', scheduleSync);
  scheduleSync();
})();
